import styled from "@emotion/styled";

export const CardContainer = styled.div`
  padding: 80px 20px;
  width: 100%;
  background: linear-gradient(160deg, rgba(255, 248, 229, 0.65) 0%, rgba(255, 242, 200, 0.65) 100%);
  border: 1px solid rgba(255, 212, 11, 0.3);
  border-radius: 16px;
  box-shadow: 0 15px 50px rgba(255, 201, 38, 0.18), 0 4px 20px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px); /* Для поддержки в Safari */
  display: flex;
  flex-direction: column;

  /* Стили для ПК-версии */
  @media (min-width: 600px) {
    width: 420px;
    max-height: 720px;
    flex-grow: 1;  
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }

  /* Стили для мобильных устройств */
  @media (max-width: 600px) {
    padding: 24px;
    height: 100vh;
    border-radius: 18px;
    border: none;
    gap: 14px;
    justify-content: center;
  }
`;

export const CardErrorContainer = styled.div`
  padding: 80px 20px;
  width: 100%;
  background: linear-gradient(160deg, rgba(255, 248, 229, 0.65) 0%, rgba(255, 242, 200, 0.65) 100%);
  border: 1px solid rgba(255, 154, 162, 0.6);
  border-radius: 16px;
  box-shadow:
    0 12px 36px rgba(255, 154, 162, 0.2),
    0 6px 18px rgba(0, 0, 0, 0.06),
    inset 0 0 18px rgba(188, 43, 44, 0.28);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px); /* Для поддержки в Safari */
  display: flex;
  flex-direction: column;

  /* Стили для ПК-версии */
  @media (min-width: 600px) {
    width: 420px;
    height: 800px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  /* Стили для мобильных устройств */
  @media (max-width: 600px) {
    padding: 24px;
    height: 100vh;
    border-radius: 18px;
    border: none;
    gap: 12px;
    justify-content: center;
  }
`;
